<template>
    <card-wrapper :title="Lang.get('employerdashboard::pages/invoices/index.title') "
                 :subtitle="Lang.get('employerdashboard::pages/invoices/index.subtitle') ">

        <template v-slot:nav aria-label="breadcrumb">
            <ol class="breadcrumb font-poppins font-weight-light font-size-14 color-blue px-0 bg-transparent">
                <li class="breadcrumb-item color-blue" aria-current="page">{{ Lang.get('employerdashboard::pages/invoices/index.title') }}</li>
            </ol>
        </template>

        <card-layout card_padding="p-0 pb-4">
            <ul class="nav nav-tabs flex-nowrap px-3 my-3" id="invoiceTab" role="tablist">

                <li class="nav-item">
                    <a class="nav-link font-poppins font-size-14 color-blue"
                       :class="{active : form.status === 'all'}"
                       id="all-tab"
                       data-toggle="tab"
                       href="#all"
                       role="tab"
                       aria-controls="home"
                       :aria-selected="{true : form.status === 'all'}"
                       @click="reset">
                        {{ Lang.get('employerdashboard::pages/invoices/index.tabs.all') }}
                        ({{totalInvoices}})
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link font-poppins font-size-14 color-blue"
                       :class="{active : form.status === 'paid'}"
                       data-toggle="tab"
                       href="#paid"
                       role="tab"
                       aria-controls="home"
                       :aria-selected="{true : form.status === 'paid'}"
                       @click="paid">
                        {{ Lang.get('employerdashboard::pages/invoices/index.tabs.paid') }}
                        ({{ totalPaidInvoices }})
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link font-poppins font-size-14 color-red"
                       :class="{active : form.status === 'open'}"
                       data-toggle="tab" href="#all" role="tab" aria-controls="home"
                       :aria-selected="{true : form.status === 'open'}"
                       @click="open">
                        {{ Lang.get('employerdashboard::pages/invoices/index.tabs.open') }}
                        ({{ totalOpenInvoices }})
                    </a>
                </li>
            </ul>
            <div class="tab-content" id="invoiceTabContent">
                <div class="tab-pane fade show active" id="all" role="tabpanel" aria-labelledby="all-tab">
                    <div id="invoiceAccordion" v-if="invoices.data.length">
                        <div class="mt-2 border-bottom" v-for="invoice in invoices.data" :key="invoice.id">
                            <inertia-link :href="route('nl.employerdashboard.invoice.details', {
                                            company_as_uuid: $page.props.auth.user.selected_company.uuid,
                                            invoice: invoice.uuid
                                        })" class="no-underline font-poppins font-weight-light font-size-18 color-blue">
                                <div class="card-header px-4 py-3 bg-white cursor-pointer collapsed">
                                    <div class="row">
                                        <div class="col">
                                            {{ invoice.created_at }}
                                        </div>
                                        <div class="col">
                                            {{ invoice.number }}
                                        </div>
                                        <div class="col">{{ invoice.total | toCurrency }}</div>
                                        <div class="col">
                                            <span
                                                class="badge font-poppins font-size-14 font-weight-semibold float-right mt-1"
                                                :class="'badge-' + invoice.status.label"
                                                v-html="invoice.status.text"></span>
                                        </div>
                                    </div>
                                </div>
                            </inertia-link>
                        </div>
                    </div>
                    <div v-else class="col-12 px-4 py-3">
                        <p class="font-poppins font-weight-light font-size-18 color-blue">
                            {{ Lang.get('employerdashboard::pages/invoices/index.no_invoices') }}</p>
                    </div>
                </div>
            </div>
            <pagination :links="invoices.links"/>
        </card-layout>
    </card-wrapper>
</template>

<script>
import CardWrapper from '@/Shared/CardWrapper';
import CardLayout from "@/Shared/CardLayout";
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'
import SyncStatus from "@/Shared/SyncStatus";
export default {
    metaInfo: { title: Lang.get('employerdashboard::pages/invoices/index.title') },
    components: {
        CardWrapper,
        CardLayout,
        Pagination,
        SyncStatus
    },
    props: {
        company: Object,
        invoices: Object,
        totalInvoices: Number,
        totalPaidInvoices: Number,
        totalOpenInvoices: Number,
        filters: Object,
        errors: Object,
        sync: Object
    },
    data() {
        return {
            form: {
                status: this.filters.status,
            },
        }
    },
    watch: {
        form: {
            handler: throttle(function() {
                const route = this.route('nl.employerdashboard.invoices.overview', {
                    company_as_uuid: this.$page.props.auth.user.selected_company.uuid
                });

                const query = pickBy(this.form)
                const data = Object.keys(query).length ? query : '';
                this.$inertia.get(route, data, {
                    preserveState: true,
                    preserveScroll: false,
                    replace: true,
                    only: [],
                })
            }, 150),
            deep: true,
        },
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null);
            this.form.status = 'all';
        },

        paid() {
            this.form.status = 'paid';
        },

        open() {
            this.form.status = 'open';
        }
    }
}
</script>
